import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setIngresoLicencia } from "../../../redux/actions";
import { useState } from "react";
import Button from "../../../components/button";

function IngresarLicencia({ closeModalIngresar, openOpcionesFotoLicencia }) {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.currentUserId);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const onSubmit = async (data, event) => {
    event.preventDefault();
    setLoading(true);
    data.user = userId;

    await dispatch(setIngresoLicencia(data))
    openOpcionesFotoLicencia()
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 "
      onClick={closeModalIngresar} /* Cierra al hacer clic fuera */
    >
      <div
        className="relative w-[20rem] sm:w-[30rem] px-5 py-8 bg-white rounded-xl flex flex-col justify-center  gap-6 mx-5 overflow-y-auto my-[2rem]"
        onClick={(e) =>
          e.stopPropagation()
        } /* Evita que el clic dentro lo cierre */
      >
        <button
          onClick={closeModalIngresar}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
        {/* Título */}
        <div className="sm:text-left text-center text-[#3d4245] text-2xl font-bold font-inter">
          Ingresar licencia
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="self-stretch flex flex-col justify-start items-start gap-4">
            <div className="self-stretch flex justify-start items-start gap-3 sm:flex-row flex-col">
              <div className="flex-grow flex flex-col justify-start items-start gap-2 w-full">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  Apellidos y Nombres
                </label>
                <input
                  placeholder="Apellidos y Nombres"
                  className="self-stretch h-[50px] p-2 rounded-md border border-[#687073] text-sm font-normal font-inter w-full flex-grow"
                  name="nombre"
                  {...register("nombre", {
                    required: "Por favor, ingrese el apellido y nombre",
                    validate: (value) => {
                      // Validar caracteres permitidos
                      const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s\-'´]+$/;
                      if (!regex.test(value)) {
                        return "El nombre solo puede contener letras, espacios, apóstrofos y guiones.";
                      }

                      // longitud mínima
                      if (value.length < 2) {
                        return "El nombre debe tener al menos 2 caracteres.";
                      }

                      // longitud máxima
                      if (value.length > 50) {
                        return "El nombre no debe superar los 50 caracteres.";
                      }

                      // espacios consecutivos
                      if (/\s{2,}/.test(value)) {
                        return "El nombre no debe contener espacios consecutivos.";
                      }

                      return true;
                    },
                    setValueAs: (value) =>
                      value
                        ?.trim()
                        .toLowerCase()
                        .replace(/\b\w/g, (char) => char.toUpperCase()), // Capitalizar nombres
                  })}
                />
              </div>
              <div className="flex-grow flex flex-col justify-start items-start gap-2 w-full">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  DNI
                </label>
                <input
                  placeholder="000000000"
                  className="self-stretch h-[50px] p-2 rounded-md border border-[#687073] text-sm font-normal font-inter w-full flex-grow"
                  type="number"
                  name="dni"
                  {...register("dni", {
                    required: "Por favor, ingrese el dni",
                    validate: (value) => {
                      // Validar que solo contenga números
                      if (!/^\d+$/.test(value)) {
                        return "El DNI solo puede contener números.";
                      }

                      // Validar longitud permitida (7 u 8 dígitos)
                      if (value.length < 6 || value.length > 9) {
                        return "El DNI debe tener entre 6 y 9 dígitos.";
                      }

                      return true;
                    },
                    setValueAs: (value) => value?.trim(), // Eliminar espacios innecesarios
                  })}
                />
              </div>
            </div>

            {/* Lic. Conducir / Fecha y hora */}
            <div className="self-stretch flex justify-start items-start gap-3 sm:flex-row flex-col">
              <div className="flex-grow flex flex-col justify-start items-start gap-2 w-full">
                <label
                  className="text-[#3d4245] text-sm font-normal font-inter"
                >
                  Lic. Conducir
                </label>
                <input
                  placeholder="000000000"
                  className="self-stretch h-[50px] p-2 rounded-md border border-[#687073] text-sm font-normal font-inter w-full flex-grow"
                  type="number"
                  name="numero"
                  {...register("numero", {
                    required: "Por favor, ingrese el número de licencia",
                    validate: (value) => {

                      if (!/^\d+$/.test(value)) {
                        return "La licencia solo puede contener números.";
                      }

                      if (value.length > 12) {
                        return "El número de licencia no debe tener más de 12 dígitos.";
                      }
                      return true;
                    },
                    setValueAs: (value) => value?.trim(), // Eliminar espacios innecesarios
                  })}
                />
              </div>


              {/* Campo Fecha y hora de ingreso */}
              <div className="flex-grow flex flex-col justify-start items-start gap-2 w-full">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  Fecha y hora
                </label>
                <div className="flex items-center gap-2 w-full">
                  <input
                    name="fecha_hora"
                    placeholder="0"
                    type="datetime-local"
                    defaultValue={(() => {
                      const ahora = new Date();

                      const ahoraArgentina = new Date(
                        ahora.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })
                      );

                      const pad = (n) => n.toString().padStart(2, "0");

                      const year = ahoraArgentina.getFullYear();
                      const month = pad(ahoraArgentina.getMonth() + 1);
                      const day = pad(ahoraArgentina.getDate());
                      const hour = pad(ahoraArgentina.getHours());
                      const minute = pad(ahoraArgentina.getMinutes());

                      // Formato: "YYYY-MM-DDTHH:mm" (para type="datetime-local")
                      return `${year}-${month}-${day}T${hour}:${minute}`;
                    })()}
                    className="self-stretch h-[50px] p-2 rounded-md border border-[#687073] text-sm font-normal font-inter w-full flex-grow"
                    {...register("fecha_hora", {
                      required: "Por favor, ingrese la fecha y hora.",
                      validate: (value) => {
                        const selectedDate = new Date(value);
                        const now = new Date();
                        const threeYearsAgo = new Date();
                        threeYearsAgo.setFullYear(now.getFullYear() - 3);

                        if (selectedDate > now) {
                          return "La fecha no puede ser superior a la actual";
                        }
                        if (selectedDate < threeYearsAgo) {
                          return `El año no puede ser menor a ${threeYearsAgo.getFullYear() + 1
                            }`;
                        }
                        return true;
                      },
                    })}
                  />
                </div>
              </div>
            </div>
            {/* Observaciones / Fecha y hora */}
            <div className="self-stretch flex justify-start items-start gap-3 sm:flex-row flex-col">
              {/* Campo Observaciones */}
              <div className="flex-grow flex flex-col justify-start items-start gap-2 w-full">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  Observaciones
                </label>

                <input
                  placeholder="Observaciones"
                  className="self-stretch h-[50px] p-2 rounded-md border border-[#687073] text-sm font-normal font-inter w-full flex-grow"
                  type="text"
                  name="observaciones"
                  {...register("observaciones", {
                    validate: (value) => {
                      // Permitir valores vacíos
                      if (!value) {
                        return true;
                      }

                      // Validar longitud máxima
                      if (value.length > 500) {
                        return "Las observaciones no pueden superar los 500 caracteres.";
                      }

                      return true; // Válido
                    },
                    setValueAs: (value) => value?.trim(), // Eliminar espacios innecesarios al inicio y final
                  })}
                />
              </div>
            </div>

            {/* Mensajes de error */}
            <div className=" text-start">
              {Object.values(errors).map((error, index) => (
                <p className="text-red-500 " key={index}>
                  {error.message}
                </p>
              ))}
            </div>

            {/* Botones */}
            <div className="self-stretch flex justify-start items-start gap-3 sm:flex-row flex-col">
              <Button
                type="submit"
                size="lg"
                fullWidth
                loading={loading}
              >
                Ingresar
              </Button>
              <Button
                variant="secondary"
                size="lg"
                fullWidth
                onClick={closeModalIngresar}
                className="sm:mb-0 mb-5"
              >
                Cancelar
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default IngresarLicencia;
